// extracted by mini-css-extract-plugin
module.exports = {"main":"Notifications_main__3naJB","box":"Notifications_box__3uQFL"};